import Image from "components/Elements/Image/Image";
import { ButtonA } from "components/Elements/Button/Button";
import { useContent } from "contexts/contentContext/contentContext";

import styles from "./pickerPromoModals.module.scss";

const PickerPromoFreeModal = () => {
  const { getHtmlByKey, getTextByKey } = useContent();

  return (
    <div className={styles.container + " " + styles.freeModal}>
      <Image
        name="home/picker-promo-anon-banner"
        ext="png"
        className={styles.image}
      />
      <h3>{getHtmlByKey("picker-promo-freeuser-modal-title")}</h3>
      <div className={styles.text}>
        <p>{getHtmlByKey("picker-promo-freeuser-modal-text")}</p>
      </div>
      <div className={styles.buttons}>
        <ButtonA page="plans" className={styles.sendButton} target="_blank">
          {getTextByKey("choose-plan-text")}
        </ButtonA>
      </div>
    </div>
  );
};

export default PickerPromoFreeModal;
